import React, { useEffect, useRef, useState } from 'react'

interface IPROPS {
  closeModal: any
  formik: any
}


const TermsConditionModal: React.FC<IPROPS> = ({ closeModal, formik }) => {

  const scrollRef = useRef<HTMLDivElement>(null);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
    
    if (formik.values.acceptTerms) {
      setIsCheckboxChecked(true);
    }
  }, [formik.values.acceptTerms]);

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    setIsCheckboxChecked(isChecked);
    formik.setFieldValue('acceptTerms', isChecked);
  };

  return (
    <div style={{ marginBottom: "100px" }}>

      <div ref={scrollRef} style={{ overflowY: "scroll", height: "60vh", marginBottom: "100px", overflowX: "hidden" }}>
        <h3>CircleOne CRM by Botgo Technologies Pvt. Ltd.</h3>

        <h4>Terms and Conditions of Service</h4>

        <p><strong>Effective Date:</strong> 20th February 2025</p>
        <p><strong>Last Updated:</strong> 24th February 2026</p>

        <p>These Terms and Conditions ("Terms") govern access to and use of CircleOne CRM, including web application, APIs, and related services ("Services") provided by BOTGO TECHNOLOGIES PRIVATE LIMITED ("Botgo", "we", "us", "our").<br />By creating an account, starting a trial, subscribing, or using the Services, you ("Customer", "you", "your") agree to these Terms on behalf of yourself and your organisation.<br />If you do not agree, you must not use the Services.</p>
        <br />

        <h5>1. Service Overview</h5>

        <p>CircleOne CRM is a cloud-based Customer Relationship Management platform designed to manage sales, support, marketing workflows, automation, and customer engagement.<br />Services are hosted exclusively within India.</p>
        <br />

        <h5>2. Eligibility and Account Responsibility</h5>
        <ul>
          <li>You must be at least 18 years old to use the Services.</li>
          <li>Customer is responsible for all activity under its account.</li>
          <li>Each user login is restricted to one individual.</li>
          <li>Sharing credentials is prohibited.</li>
          <li>Customer shall ensure authorised access only.</li>
        </ul>
        <br />

        <h5>3. Subscription, Billing and Payments</h5>
        <ul>
          <li>Plans and pricing are available at our website</li>
          <li>Free trial: 15 days unless otherwise stated.</li>
          <li>Subscription charges are payable in advance.</li>
          <li>Subscriptions automatically renew unless cancelled before renewal date.</li>
          <li>Fees are exclusive of applicable taxes including GST.</li>
          <li>Non payment may result in suspension after notice.</li>
          <li>Subscription fees are non refundable except where required by law.</li>
        </ul>
        <br />

        <h5>4. Licence Grant</h5>

        <p>Botgo grants Customer a limited, non exclusive, revocable licence to use the Services for internal business purposes during the subscription term.<br />Customer may not:</p>
        <ul>
          <li>Resell or sub license the Services</li>
          <li>Reverse engineer or attempt to access source code</li>
          <li>Use Services for unlawful or fraudulent purposes</li>
          <li>Violate data protection, privacy, or communication laws</li>
          <li>Upload malicious software</li>
        </ul>
        <br />

        <h5>5. Hosting and Data Location</h5>
        <ul>
          <li>All Customer Data is hosted and processed within data centres located in India.</li>
          <li>Botgo does not intentionally transfer Customer Data outside India unless legally required.</li>
          <li>If legal or regulatory requirements mandate transfer, Botgo will ensure lawful safeguards as applicable.</li>
        </ul>
        <br />

        <h5>6. Customer Data Ownership</h5>
        <ul>
          <li>Customer retains full ownership of Customer Data.</li>
          <li>Botgo processes Customer Data only to provide the Services and related support.</li>
          <li>Botgo does not sell or monetise Customer Data.</li>
        </ul>
        <br />

        <h5>7. Data Protection and Privacy (DPDP & GDPR Aligned)</h5>

        <h6>7.1 Roles</h6>

        <p>Customer acts as Data Fiduciary under the Digital Personal Data Protection Act, 2023 (DPDP Act) and Controller under GDPR where applicable.<br />Botgo acts as Data Processor under DPDP and Processor under GDPR when processing Customer Data.</p>

        <h6>7.2 Customer Obligations</h6>

        <p>Customer confirms that:</p>
        <ul>
          <li>It provides required privacy notices to individuals whose data is entered into the CRM.</li>
          <li>It obtains valid consent where required under law.</li>
          <li>It processes personal data lawfully and for legitimate purposes.</li>
          <li>It manages opt out, withdrawal of consent, and grievance handling as required by law.</li>
        </ul>

        <h6>7.3 Security Safeguards</h6>

        <p>Botgo maintains reasonable technical and organisational security measures including:</p>
        <ul>
          <li>Role based access control</li>
          <li>Encrypted transmission where applicable</li>
          <li>Access monitoring</li>
          <li>System monitoring</li>
          <li>Infrastructure level safeguards</li>
        </ul>

        <h6>7.4 Personal Data Breach</h6>

        <p>If Botgo becomes aware of a personal data breach affecting Customer Data, Botgo will notify Customer without undue delay and provide available details.<br/>Customer remains responsible for notifying authorities or affected individuals where required under applicable law.</p>
        <br />

        <h5>8. Support Process and Access Authorisation</h5>

        <p>Support is provided exclusively via Email Support Channel at: support@botgo.io<br />Botgo does not provide remote desktop, screen share, or live system access sessions.</p>

        <h6>8.1 Support Access Consent</h6>

        <p>By raising a support ticket via email, Customer expressly authorises Botgo to:</p>
        <ul>
          <li>Access the minimum necessary account configuration, logs, and Customer Data required to investigate and resolve the issue.</li>
          <li>Process such data solely for support, troubleshooting, and system improvement purposes.</li>
          <li>Limit access to authorised support personnel bound by confidentiality obligations.</li>
        </ul>

        <p>Customer confirms that it has lawful authority and required permissions to allow such access.<br />If Customer does not wish to provide data access, Customer may share masked logs or relevant information via email, which may impact resolution time.</p>
        <br />

        <h5>9. Communication Features</h5>

        <p>CircleOne CRM may include email, messaging, and workflow communication tools.</p>

        <p>Customer is solely responsible for:</p>
        <ul>
          <li>Compliance with anti spam laws</li>
          <li>Marketing communication regulations</li>
          <li>Consent collection and opt out management</li>
          <li>Lawful use of email or messaging tools</li>
        </ul>

        <p><strong>Important:</strong></p>

        <p>CircleOne CRM does not provide call recording functionality.<br />Customer is responsible for any external telephony system compliance.</p>
        <br />

        <h5>10. Data Retention and Deletion</h5>
        <ul>
          <li>Upon termination or cancellation, Customer Data will be retained for 30 days from termination date ("Data Retention Period").</li>
          <li>During this 30 day period, Customer may request data export.</li>
          <li>After 30 days, Customer Data will be permanently deleted in the normal course of operations.</li>
          <li>Deleted data may remain temporarily in encrypted backups until overwritten.</li>
          <li>Data required for compliance, security logs, billing, or legal purposes may be retained as required by law.</li>
        </ul>

        <br />

        <h5>11. Sub Processors</h5>

        <p>Botgo may use third party service providers located in India for:</p>
        <ul>
          <li>Cloud hosting</li>
          <li>Infrastructure monitoring</li>
          <li>Payment processing</li>
          <li>Email infrastructure</li>
        </ul>

        <p>All sub processors are contractually bound to confidentiality and security standards.</p>
        <br />

        <h5>12. Service Availability</h5>

        <p>Services are provided on an "as available" basis.<br />Botgo may perform scheduled maintenance and deploy updates for performance, security, or feature enhancements.</p>
        <br />

        <h5>13. Confidentiality</h5>

        <p>Both parties agree to maintain confidentiality of proprietary and confidential information including Customer Data.</p>
        <br />

        <h5>14. Disclaimer of Warranties</h5>

        <p>Services are provided without warranties of uninterrupted or error free performance.<br/>Botgo disclaims implied warranties including merchantability and fitness for a particular purpose to the maximum extent permitted by law.</p>
        <br />

        <h5>15. Limitation of Liability</h5>

        <p>To the maximum extent permitted by law:</p>
        <ul>
          <li>Botgo is not liable for indirect, incidental, consequential, or special damages.</li>
          <li>Botgo's total liability is limited to subscription fees paid by Customer in the preceding 12 months.</li>
          <li>Nothing limits liability where such limitation is not permitted by law.</li>
        </ul>
        <br />

        <h5>16. Indemnity</h5>

        <p>Customer agrees to indemnify Botgo against claims arising from:</p>
        <ul>
          <li>Customer's misuse of Services</li>
          <li>Unlawful communications</li>
          <li>Failure to obtain required consents</li>
          <li>Violation of data protection laws</li>
        </ul>
        <br />

        <h5>17. Termination</h5>

        <p>Botgo may suspend or terminate Services if:</p>
        <ul>
          <li>Customer breaches Terms</li>
          <li>Payment is not made</li>
          <li>Legal or regulatory requirement arises</li>
        </ul>

        <p>Customer may terminate by cancelling subscription through the account or by email.</p>
        <br />

        <h5>18. Grievance and Contact</h5>

        <p>For privacy or data protection matters:</p>

        <p>BOTGO TECHNOLOGIES PRIVATE LIMITED<br/>B-67, 2nd Floor, CESPL Building<br/>Sector 67, Noida, 201301<br/>Uttar Pradesh, India</p>

        <p>📧 info@botgo.io<br />📞 +91 9579131948</p>
        <br />

        <h5>19. Governing Law and Dispute Resolution</h5>

        <p>These Terms are governed by Indian law including:</p>
        <ul>
          <li>Indian Contract Act, 1872</li>
          <li>Information Technology Act, 2000</li>
          <li>Digital Personal Data Protection Act, 2023</li>
        </ul>

        <p>Disputes shall first be resolved amicably.<br />If unresolved, disputes shall be referred to arbitration under the Arbitration and Conciliation Act, 1996.<br />Seat of arbitration: Maharashtra, India.<br />Courts at Maharashtra shall have jurisdiction.</p>

        <div className="d-flex justify-content-end me-5 mt-10">
          <div
            className="form-check form-check-custom form-check-solid"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "baseline",
            }}
          >
            <div>
              <input
                className="form-check-input"
                type="checkbox"
                checked={isCheckboxChecked}
                onChange={handleCheckboxChange}
              />
              <label
                className="form-check-label fw-bold text-gray-700 fs-6 required"
                htmlFor="kt_login_toc_agree"
              >
                I confirm that I am authorised to accept these Terms on behalf of my organisation and agree that Botgo may process data as required to provide CircleOne CRM Services.
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TermsConditionModal